
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nse468aaf12a02d7e880b5140ab3d9194fen from './en.yaml'
            i18n.addResourceBundle('en', 'e468aaf12a02d7e880b5140ab3d9194f', flattenObject(nse468aaf12a02d7e880b5140ab3d9194fen), true, true);
        
        export default 'e468aaf12a02d7e880b5140ab3d9194f';
    